import { Box, styled } from '@mui/system';

export const EconsultAppLayout = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
});
